import { useQuery } from '@tanstack/react-query';
// import { calculateAge } from '../utils/calculateAge';

const usePetsList = () => {
  return useQuery({
    queryKey: ['pets'],
    queryFn: async () => {
      const response = await fetch(
        import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_GET_DOGS
      );
      if (!response.ok) {
        throw new Error('Failed to fetch pets');
      }
      return response.json();
    },
    select: (data) => {
      const order = {
        available: 0,
        fosterdk: 0,
        fostercz: 0,
        reserved: 1,
        adopted: 2,
      };
      return [...data].sort(
        (a, b) =>
          (order[a.status?.toLowerCase()] ?? 99) -
          (order[b.status?.toLowerCase()] ?? 99)
      );
    },
    staleTime: 1000 * 60 * 30,
  });
};

export default usePetsList;
